import { useQuery } from "@tanstack/react-query";
import { SuperBillControllerApi } from "../../../services";
import { getConfigObject, getXtenantId } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

export const useGetSuperBillDetailsByList = (superBillIds: string[]) =>
  useQuery({
    queryKey: ["get-super-bill-details-by-list", superBillIds],
    enabled: !!superBillIds,
    queryFn: async () =>
      new SuperBillControllerApi(getConfigObject()).getSuperBills(
        superBillIds,
        getXtenantId()
      ),
  });
